.modalTitle {
  margin-top: 25px;
  margin-bottom: 16px;
  color: var(--x-color-action-orange-active);
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
}

.modalSubtitle {
  font-size: 16px;
  line-height: 24px;
}
